import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_URL } from '../../utils/env';

const SEO = ({ title, description, image, url, rawTitle = false }) => {
  const siteTitle = 'postpop';
  const defaultDescription =
    '포스트팝은 음악 리뷰 커뮤니티입니다. 앨범 리뷰와 함께 최신 음악 뉴스, 플레이리스트 만들기까지. 나만의 음악 취향을 아카이빙 해보세요.';
  const defaultImage = `${SITE_URL}/og-image-rec.png`;
  const defaultUrl = SITE_URL;

  const finalTitle = title ? (rawTitle ? title : `${title} - ${siteTitle}`) : siteTitle;
  const finalDescription = description || defaultDescription;
  const finalImage = image || defaultImage;
  const finalUrl = url || defaultUrl;

  return (
    <Helmet>
      {/* 기본 Meta Tags */}
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={finalUrl} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={finalImage} />

      {/* Canonical URL */}
      <link rel="canonical" href={finalUrl} />
    </Helmet>
  );
};

export default SEO;
